export type InkPageTurn = 0 | 90 | -90;

export function isScreenLandscape(width: number, height: number): boolean {
  return width > height;
}

/**
 * Portrait webview, device tilted to landscape: rotate the page.
 * If the screen already turned, leave the page alone so the OS rotation is not doubled.
 */
export function nextPageTurn(
  current: InkPageTurn,
  beta: number,
  gamma: number,
  screenLandscape: boolean,
): InkPageTurn {
  if (screenLandscape) {
    return 0;
  }
  const absGamma = Math.abs(gamma);
  const absBeta = Math.abs(beta);
  if (current === 0) {
    if (absGamma > 55 && absGamma > absBeta) {
      return gamma > 0 ? -90 : 90;
    }
    return 0;
  }
  if (absGamma < 30 || absBeta > absGamma + 15) {
    return 0;
  }
  return gamma > 0 ? -90 : 90;
}

export function rotatedScrollerStyle(
  turn: InkPageTurn,
  stageWidth: number,
  stageHeight: number,
): {
  position?: 'absolute';
  width: number | string;
  height: number | string;
  left?: string;
  top?: string;
  transform?: string;
} {
  if (turn === 0 || stageWidth <= 0 || stageHeight <= 0) {
    return { width: '100%', height: '100%' };
  }
  return {
    position: 'absolute',
    width: stageHeight,
    height: stageWidth,
    left: '50%',
    top: '50%',
    transform: `translate(-50%, -50%) rotate(${turn}deg)`,
  };
}

export async function requestDeviceOrientation(): Promise<void> {
  const Candidate = DeviceOrientationEvent as unknown as {
    requestPermission?: () => Promise<string>;
  };
  if (typeof Candidate.requestPermission === 'function') {
    await Candidate.requestPermission();
  }
}
